import React from "react";
import { motion } from "framer-motion";

export function ScoreRing({ value, label, color = "#3B8268" }) {
  const circumference = 2 * Math.PI * 42;
  const offset = circumference - (value / 100) * circumference;
  return (
    <div className="score-ring" data-testid={`score-ring-${label}`}>
      <svg width="110" height="110" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="42" fill="none" stroke="#EAE5DB" strokeWidth="7" />
        <motion.circle
          cx="50" cy="50" r="42" fill="none" stroke={color} strokeWidth="7"
          strokeLinecap="round"
          transform="rotate(-90 50 50)"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.4, ease: "easeOut" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-heading font-extrabold text-3xl text-[#292524] leading-none">{value}</div>
        <div className="overline mt-1">{label}</div>
      </div>
    </div>
  );
}
